import {
  EDIT_GRAPH_SCHEMA_VERSION,
  EDIT_GRAPH_SCHEMA_VERSION_V1,
  type EditGraph,
} from "../contracts/edit-graph.js";
import { ValidationError } from "../validation/helpers.js";

/**
 * Explicit v1 → v2 EditGraph migration.
 * Preserves ops, cursor, undo/redo branch, seed, and pack identity bit-for-bit.
 * No-op when already at the current schema version.
 */
export function migrateEditGraphToCurrent(graph: {
  schemaVersion: number;
  sourcePackId: string;
  sourcePackVersion: string;
  tickRate: number;
  seed: number;
  ops: EditGraph["ops"];
  cursor: number;
}): EditGraph {
  if (graph.schemaVersion === EDIT_GRAPH_SCHEMA_VERSION) {
    return graph as EditGraph;
  }
  if (graph.schemaVersion === EDIT_GRAPH_SCHEMA_VERSION_V1) {
    return {
      schemaVersion: EDIT_GRAPH_SCHEMA_VERSION,
      sourcePackId: graph.sourcePackId,
      sourcePackVersion: graph.sourcePackVersion,
      tickRate: graph.tickRate,
      seed: graph.seed,
      ops: graph.ops,
      cursor: graph.cursor,
    };
  }
  throw new ValidationError(
    "schemaVersion",
    `unsupported version ${String(graph.schemaVersion)}`,
  );
}

export function isSupportedEditGraphSchemaVersion(version: unknown): version is 1 | 2 {
  return version === EDIT_GRAPH_SCHEMA_VERSION_V1 || version === EDIT_GRAPH_SCHEMA_VERSION;
}
